import { render } from "./BackorderInquiryPopUp.vue?vue&type=template&id=58b50c71"
import script from "./BackorderInquiryPopUp.vue?vue&type=script&lang=js"
export * from "./BackorderInquiryPopUp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__